import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, useFormikContext } from 'formik'
import { reduxBatch } from '@manaflair/redux-batch'

import { useDispatch, useSelector } from 'react-redux'
import { uiActions } from '../../../store/slices'
import { getJobSettingsState, getRoofState, getWallState } from '../../../store/slices/selectors'

import { useLazyEffect } from '../../../../../utils/hooks/useLazyEffect'
import { getInputNameByField } from '../../../common/fns'

import { InputSchema } from '../../../common/validation'
import { APPLICATION_TYPES } from '../../../common/constants'

const FormCheckErrors = () => {
  const dispatch = useDispatch()
  const formik = useFormikContext()

  useLazyEffect(() => {
    const inputErrorsMsg = Object.keys(formik.errors).reduce((result, field) => {
      result.push(
        `${getInputNameByField(
          field,
          formik.values.applicationType,
          formik.values.roofMemberType,
        )}: ${formik.errors[field]}`,
      )
      return result
    }, [])

    const { f1, f2, f2Away, uplift, download, applicationType } = formik.values
    let inputWarning = false
    if (
      (Number(uplift) > 0 && (Number(f1) > 0 || Number(f2) > 0 || Number(f2Away) > 0)) ||
      (applicationType === APPLICATION_TYPES.PERPENDICULAR_TO_WALL &&
        Number(download) > 0 &&
        (Number(f1) > 0 || Number(f2) > 0))
    )
      inputWarning = true

    reduxBatch([
      dispatch(
        uiActions.updateInputErrors(inputErrorsMsg.length ? inputErrorsMsg.join('<br />') : null),
      ),
      dispatch(uiActions.modifyInput({ name: 'inputWarning', value: inputWarning })),
    ])
  }, [formik.errors, formik.values])

  return <Fragment />
}

const FormControlWrapper = (props) => {
  const jobSettings = useSelector(getJobSettingsState)
  const roof = useSelector(getRoofState)
  const wall = useSelector(getWallState)

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...jobSettings,
        ...roof,
        roofMemberType: roof.memberType,
        roofType: roof.type,
        ...wall,
      }}
      validationSchema={InputSchema}
      validateOnMount
    >
      <Form>
        <FormCheckErrors />
        {props.children}
      </Form>
    </Formik>
  )
}

FormControlWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default FormControlWrapper
